import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Label } from '../../../../shared/compass-ui'
import MoneyInput from '../../../shared/MoneyInput'
import TextInputError from '../../../shared/TextInputError'

const AccountBalance: FC = () => {
  const {
    formState: {
      errors: { totalAccountBalance: totalAccountBalanceError },
    },
  } = useFormContext()

  return (
    <div className="mt-6">
      <Label htmlFor="total-account-balance-input">
        {EXTRA_QUESTION_LABELS.totalAccountBalance}
      </Label>
      <MoneyInput
        name="totalAccountBalance"
        className={`border-2 font-normal p-4 pr-16 rounded w-full pl-8 ${
          typeof totalAccountBalanceError?.message === 'string'
            ? 'border-red-600 outline-red-600 focus:border-red-600 bg-[url(/assets/dollar.svg),_url(/assets/error.svg)] bg-no-repeat bg-[position:left_16px_center,_right_16px_center]'
            : 'border-ink-400 focus:border-blue-600 outline-blue-600 bg-dollar bg-no-repeat bg-[left_16px_center]'
        }`}
        error={typeof totalAccountBalanceError?.message === 'string'}
        id="total-account-balance-input"
        maxLength={10}
      />
      {typeof totalAccountBalanceError?.message === 'string' && (
        <TextInputError>{totalAccountBalanceError.message}</TextInputError>
      )}
    </div>
  )
}

export default AccountBalance
